export const FORBIDDEN_CHARACTERS = ['<', '>'] as const;

export const FORBIDDEN_CHARACTERS_MESSAGE = FORBIDDEN_CHARACTERS.join(', ');

export const PASSWORD_RULE_KEY = 'Password must include one letter and one number';

export const FALLBACK_MESSAGES: Record<string, (field: string, param?: unknown) => string> = {
  required: (field) => `${field} is required`,
  digits: (_, param) => `Enter exactly ${param ?? 'the required number of'} digits`,
  default: (field) => `${field} is invalid`,
};
